import * as Locale from '../../util/Locale.ts';
import * as DateUtils from '../DateUtils.ts';

function handleRecurrencyBy(bys, obj) {
  function getter(itemInObj) {
    if (typeof obj === 'function') {
      return obj(itemInObj);
    } else {
      return obj[itemInObj];
    }
  }

  if (bys instanceof Array) {
    return bys.map(getter).join(', ');
  } else {
    return getter(bys);
  }
}

function replacer(options, daysNumber, monthNames, dayNames, relativeNumber) {
  return function (g) {
    if (g === '$i') {
      return options.interval;
      // jour du mois
    } else if (g === '$d') {
      return handleRecurrencyBy(options.bymonthday, daysNumber);
      // mois
    } else if (g === '$m') {
      return handleRecurrencyBy(options.bymonth, monthNames);
      // numéro relatif de semaine (1er, 2e, dernier…)
    } else if (g === '$n') {
      let ns = [];
      if (options.byweekday && options.byweekday.length) {
        ns = options.byweekday
          .map(obj => obj.n)
          .filter(n => n != null);
      }
      // Si byweekday.n n'est pas utilisé, on retombe sur bysetpos
      if (!ns.length && options.bysetpos != null) {
        if (Array.isArray(options.bysetpos)) {
          ns = options.bysetpos;
        } else {
          ns = [options.bysetpos];
        }
      }
      return handleRecurrencyBy(ns, relativeNumber);
      // jour de la semaine
    } else if (g === '$w') {
      return handleRecurrencyBy(
        options.byweekday.map(obj => (obj.weekday + 1) % 7),
        dayNames
      );
      // jour de la semaine au pluriel
    } else if (g === '$W') {
      return handleRecurrencyBy(
        options.byweekday.map(obj => (obj.weekday + 1) % 7),
        dayNames.map(d => d + 's')
      );
    }
  };
}

function replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber) {
  tpl = tpl.replace(/<([^>]*)>/g, function (all, subRaw) {
    var subs = subRaw.split('|');

    for (var i = 0; i < subs.length; i++) {
      var sub = subs[i],
        useSub = true;
      // on utilise replace mais on ne veut pas le résultat, juste tester les conditions
      sub.replace(/\$./g, function (g) {
        if (g === '$i') {
          useSub &= options.interval != null && options.interval !== 1;
        } else if (g === '$d') {
          useSub &= options.bymonthday != null;
        } else if (g === '$m') {
          useSub &= options.bymonth != null;
        } else if (g === '$n') {
          let nVal = null;


          // priorité : n sur byweekday (si déjà là)
          if (options.byweekday && options.byweekday[0] && options.byweekday[0].n != null) {
            nVal = options.byweekday[0].n;
          }
          // fallback : bysetpos (cas RRULE type BYDAY=WE;BYSETPOS=2)
          else if (options.bysetpos != null) {
            if (Array.isArray(options.bysetpos)) {
              nVal = options.bysetpos[0];
            } else {
              nVal = options.bysetpos;
            }
          }

          useSub &= (nVal != null && relativeNumber[nVal] != null);
        } else if (g === '$w') {
          useSub &= options.byweekday != null;
        } else if (g === '$W') {
          useSub &= options.byweekday != null;
        }
      });
      if (useSub) return sub;
    }
    return '';
  });
  return tpl.replace(
    /\$./g,
    replacer(options, daysNumber, monthNames, dayNames, relativeNumber)
  );
}

var byLang = {
  // ==========================
  // ENGLISH
  // ==========================
  en: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i < -3) return -i + 'th last day';
        if (i === -3) return '3rd last day';
        if (i === -2) return '2nd last day';
        if (i === -1) return 'last day';
        if (i === 1) return '1st';
        if (i === 2) return '2nd';
        if (i === 3) return '3rd';
        else return i + 'th';
      },
      relativeNumber = {
        '1': '1st',
        '2': '2nd',
        '3': '3rd',
        '4': '4th',
        '-1': 'last',
        '-2': '2nd last',
        '-3': '3rd last',
        '-4': '4th last'
      },
      tpl;
    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        '$m on the $d',
        '<on the $d|on the $n $w>',
        'the $W',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'Every $i years<, $m on the $d>',
        'Every $i months<, on the $d|, on the $n $w>',
        'Every $i weeks<, the $W>',
        'Every $i days'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'Every <$m on the $d|$m on the $n $w|year>',
        'Every month<, on the $d|, on the $n $w>',
        'Every <$W|week>',
        'Everyday'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ', until ' + DateUtils.format(options.until, 'LL', options.lang);
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + ' times';
    }
    return res;
  },

  // ==========================
  // FRANÇAIS
  // ==========================
  fr: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i < -1) return -i + 'ème dernier jour';
        if (i === -1) return 'dernier jour';
        if (i === 1) return '1er';
        else return i;
      },
      relativeNumber = {
        '1': '1er',
        '2': '2ème',
        '3': '3ème',
        '4': '4ème',
        '-1': 'dernier',
        '-2': 'avant dernier',
        '-3': '3ème dernier',
        '-4': '4ème dernier'
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        'les $d $m',
        '<le $d|le $n $w>',
        'les $W',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'Tous les $i ans<, les $d $m>',
        'Tous les $i mois<, le $d|, le $n $w>',
        'Toutes les $i semaines<, les $W>',
        'Tous les $i jours'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'Tous les <$d $m|$ns $W de $m|ans>',
        'Tous les mois<, le $d|, le $n $w>',
        '<Tous les $W|Toutes les semaines>',
        'Tous les jours'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);
    if (options.until != undefined) {
      res += ", jusqu'au " + DateUtils.format(options.until, 'LL', options.lang);
    }
    if (options.count != undefined) {
      res += ', ' + options.count + ' fois';
    }
    //fix french "de avril" => "d'avril"
    res = res.replace(/ ([ld])e ([aeiouy])/g,' $1\'$2')
    return res;
  },

  // ==========================
  // ALBANAIS (SQ)
  // ==========================
  sq: function (options) {
    var
      dayNames = DateUtils.getWeekDaysRaw(),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw()),

      daysNumber = function(i){
        if(i === -1) return "dita e fundit";
        if(i < -1) return "dita e " + (-i) + " fundit";
        return i;
      },

      relativeNumber = {
        "1":"i pari",
        "2":"i dyti",
        "3":"i treti",
        "4":"i katërti",
        "-1":"i fundit",
        "-2":"i parafundit",
        "-3":"i treti nga fundi",
        "-4":"i katërti nga fundi"
      },

      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        "$d $m",
        "<$d|$n $w>",
        "$w",
        ""
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        "Çdo $i vjet<, $d $m>",
        "Çdo $i muaj<, $d|, $n $w>",
        "Çdo $i javë<, $w>",
        "Çdo $i ditë"
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        "Çdo <$d $m|vit>",
        "Çdo muaj<, $d|, $n $w>",
        "Çdo <$w|javë>",
        "Çdo ditë"
      ]);
    }

    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ", deri në " + DateUtils.format(options.until, "LL", options.lang);
    }
    if (options.count !== undefined) {
      res += ", " + options.count + " herë";
    }
    return res;
  },

  // ==========================
  // PORTUGAIS (PT)
  // ==========================
  pt: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i < -2) return -i + '° últimos dias';
        if (i === -2) return 'penúltimos dias';
        if (i === -1) return 'últimos dias';
        return i;
      },
      relativeNumber = {
        '1': '1°',
        '2': '2°',
        '3': '3°',
        '4': '4°',
        '-1': 'últimos',
        '-2': 'penúltimos',
        '-3': '3° últimos',
        '-4': '4° últimos'
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        '$d $m',
        '<$d|$n $w>',
        '$w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'A cada $i anos<, $d $m>',
        'A cada $i mês<, $d|, $n $w>',
        'A cada $i semanas<, $w>',
        'A cada $i dias'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'Todos os <$d $m|anos>',
        'Todos os meses<, no dia $d>',
        'Todos os <$w|semanas>',
        'Todos os dias'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ', até ' + DateUtils.format(options.until, 'LL', options.lang);
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + ' vezes';
    }
    return res;
  },

  // ==========================
  // ESPAGNOL (ES)
  // ==========================
  es: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i < -2) return -i + '° últimos días';
        if (i === -2) return 'penúltimos días';
        if (i === -1) return 'últimos días';
        return i;
      },
      relativeNumber = {
        '1': '1°',
        '2': '2°',
        '3': '3°',
        '4': '4°',
        '-1': 'últimos',
        '-2': 'penúltimos',
        '-3': '3° últimos',
        '-4': '4° últimos'
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        'el $d $m',
        '<el $d|el $n $w>',
        'los $w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'Cada $i años<, el $d $m>',
        'Cada $i meses<, el $d|el $n $w>',
        'Cada $i semanas<, los $w>',
        'Cada $i días'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'todos los <$d $m|años>',
        'Cada mes<, el $d>',
        '<todos los $w|todas las semanas>',
        'todos los días'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ', hasta el ' + DateUtils.format(options.until, 'LL', options.lang);
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + ' veces';
    }
    return res;
  },

  // ==========================
  // ITALIEN (IT)
  // ==========================
  it: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i < -2) return -i + '° ultimo giorno';
        if (i === -2) return 'penultimo giorno';
        if (i === -1) return 'ultimo giorno';
        return i;
      },
      relativeNumber = {
        '1': '1°',
        '2': '2°',
        '3': '3°',
        '4': '4°',
        '-1': 'ultimo',
        '-2': 'penultimo',
        '-3': '3° ultimo',
        '-4': '4° ultimo'
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        'il $d $m',
        '<il $d|il $n $w>',
        '$w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'Ogni $i anni<, il $d $m>',
        'Ogni $i mesi<, il $d|il $n $w>',
        'Ogni $i settimane<, il $w>',
        'ogni $i giorni'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'Ogni <$d $m|anno>',
        'Ogni mese<, il $d>',
        'Ogni $w',
        'Quotidiano'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ', fino al ' + DateUtils.format(options.until, 'LL', options.lang);
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + ' volte';
    }
    return res;
  },

  // ==========================
  // JAPONAIS (JA)
  // ==========================
  ja: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        return i;
      },
      relativeNumber = {
        '1': '第1',
        '2': '第2',
        '3': '第3',
        '4': '第4',
        '-1': '先週の',
        '-2': '-2',
        '-3': '-3',
        '-4': '-4'
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        '毎年$m$d',
        '<$d|$n $w>',
        '$w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        '毎$i年<$m$d>',
        '毎$i月<,$d|$n$w>',
        '毎$i週<$w>',
        '毎$i日'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        '毎<$d$m|年>',
        '毎月<$d>',
        '毎$w',
        '毎日'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += DateUtils.format(options.until, 'LL') + 'まで';
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + '回';
    }
    return res;
  },

  // ==========================
  // RUSSE (RU)
  // ==========================
  ru: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        return i;
      },
      relativeNumber = {
        "1":"первый",
        "2":"второй",
        "3":"третий",
        "4":"четвёртый",
        "-1":"последний",
        "-2":"предпоследний",
        "-3":"треть с конца",
        "-4":"четвёртый с конца"
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        'каждый $d $m',
        '<$d|$n $w>',
        'каждый $w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'каждые $i года<, $d $m>',
        'каждые $i месяца<, $d |, $n $w>',
        'каждые $i недели<, $w>',
        'каждые $i дня'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'каждые <$d $m|$n $w $m|года>',
        'каждый месяц<$d | $n $w>',
        '<каждый $w|каждую неделю>',
        'ежедневно'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ' до ' + DateUtils.format(options.until, 'LL', options.lang);
    }
    // Insert space between month and day if missing
    res = res.replace(/([а-яА-Я]+)(\d)/g, "$1 $2");

    if (options.count !== undefined) {
      res += ', ' + options.count + ' раз';
    }
    return res;
  },

  // ==========================
  // ALLEMAND (DE)
  // ==========================
  de: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i < -1) return -i + '° letzte Tage';
        if (i === -1) return 'letzte Tage';
        return i;
      },
      relativeNumber = {
        '1': 'zuerst',
        '2': 'zweite',
        '3': 'dritte',
        '4': 'vierte',
        '-1': 'letzte',
        '-2': 'zweite letzte',
        '-3': 'dritte letzte',
        '-4': 'vierte letzte'
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        '$d $m',
        '<$d|der $n $w>',
        '$w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'Alle $i Jahre<, $d $m>',
        'Alle $i Monate<, $d|, der $n $w>',
        'Alle $i Wochen<, $w>',
        'Alle $i Tage'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'Jedes <$d $m|Jahr>',
        'Jeden <$d des Monats|$n $w im Monat|Monat>',
        '<Jeden $w|Jede Woche>',
        'Täglich'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ', bis ' + DateUtils.format(options.until, 'LL', options.lang);
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + ' mal';
    }
    return res;
  },
  // ==========================
  // NL
  // ==========================
  nl: function (options) {
    var
      dayNames = DateUtils.getWeekDaysRaw(),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw()),
      daysNumber = function(i){
        if(i === -1) return "laatste dag";
        if(i < -1) return (-i) + "e laatste dag";
        if(i === 1) return "1e";
        if(i === 2) return "2e";
        if(i === 3) return "3e";
        return i + "e";
      },
      relativeNumber = {
        "1":"1e",
        "2":"2e",
        "3":"3e",
        "4":"4e",
        "-1":"laatste",
        "-2":"op één na laatste",
        "-3":"op twee na laatste",
        "-4":"op drie na laatste"
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        "$d $m",
        "<$d|$n $w>",
        "$W",
        ""
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        "Elke $i jaar<, $d $m>",
        "Elke $i maand<, $d|, $n $w>",
        "Elke $i weken<, $W>",
        "Elke $i dagen"
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        "Elke <$d $m|jaar>",
        "Elke maand<, $d|, $n $w>",
        "<Elke $W|Elke week>",
        "Elke dag"
      ]);
    }

    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ", tot " + DateUtils.format(options.until, "LL", options.lang);
    }
    if (options.count !== undefined) {
      res += ", " + options.count + " keer";
    }
    return res;
  },
  // ==========================
  // CORÉEN (KO)
  // ==========================
  ko: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i === -1) return '마지막 날';
        return i + '일';
      },
      relativeNumber = {
        '1': '첫째',
        '2': '둘째',
        '3': '셋째',
        '4': '넷째',
        '-1': '마지막',
        '-2': '지난 둘째',
        '-3': '지난 셋째',
        '-4': '지난 넷째'
      },
      tpl;

    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        '매년 $m $d',
        '<매달 $d|매달 $n $w>',
        '매주 $w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        '매 $i년<$m $d>',
        '매 $i개월<$d|$n $w>',
        '매 $i주<$w>',
        '매 $i일'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        '매년<$m $d|$m $n $w>',
        '매달<$d|$n $w>',
        '<매주 $w|매주>',
        '매일'
      ]);
    }

    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ', ' + DateUtils.format(options.until, 'LL', options.lang) + '까지';
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + '회';
    }
    return res;
  },

  // ==========================
  // SVENSKA (SV)
  // ==========================
  sv: function (options) {
    var dayNames = DateUtils.getWeekDaysRaw(options.lang),
      monthNames = [0].concat(DateUtils.getMonthDaysRaw(options.lang)),
      daysNumber = function (i) {
        if (i < -1) return Math.abs(i) + ':e sista dagen';
        if (i === -1) return 'sista dagen';
        if (i === 1) return '1:a';
        if (i === 2) return '2:a';
        else return i + ':e';
      },
      relativeNumber = {
        '1': 'första',
        '2': 'andra',
        '3': 'tredje',
        '4': 'fjärde',
        '-1': 'sista',
        '-2': 'näst sista',
        '-3': 'tredje sista',
        '-4': 'fjärde sista'
      },
      tpl;


    if (options.simple) {
      tpl = handleRecurrencyBy(options.freq, [
        '$m den $d',
        '<den $d|den $n $w>',
        '$w',
        ''
      ]);
    } else if (options.interval > 1) {
      tpl = handleRecurrencyBy(options.freq, [
        'Vart $i:e år<, $m den $d>',
        'Var $i:e månad<, den $d|, den $n $w>',
        'Var $i:e vecka<, $w>',
        'Var $i:e dag'
      ]);
    } else {
      tpl = handleRecurrencyBy(options.freq, [
        'Varje <$m den $d|$m den $n $w|år>',
        'Varje månad<, den $d|, den $n $w>',
        'Varje <$w|vecka>',
        'Varje dag'
      ]);
    }
    var res = replace(tpl, options, daysNumber, monthNames, dayNames, relativeNumber);

    if (options.until !== undefined) {
      res += ', till ' + DateUtils.format(options.until, 'LL', options.lang);
    }
    if (options.count !== undefined) {
      res += ', ' + options.count + ' gånger';
    }
    return res;
  }
};

function write(options,locale = Locale.get().substring(0, 2)) {
  try {
    if (byLang[locale]) {
      return byLang[locale](options);
    } else {
      return byLang['en'](options);
    }
  } catch (e) {
    console.log(e);
    return '';
  }
}

export { write };
